import { Flags } from 'graphql/flags.generated'
import { useFlagsQuery } from 'graphql/hooks.generated'
import { FlagsQuery } from 'graphql/types.generated'
import React, { useContext, useMemo } from 'react'

type FlagsQueryModel = FlagsQuery['info']['flags']

export type FlagsContextModel = {
  [key in Flags]: boolean
}

interface FlagsProviderProps {
  children: React.ReactNode
}

export const FlagsContext = React.createContext<FlagsContextModel>({} as FlagsContextModel)

export function FlagsProvider({ children }: FlagsProviderProps) {
  const {
    data: { info: { flags } = {} },
  } = useFlagsQuery({
    fetchPolicy: 'cache-first',
  })

  const value = useMemo(() => reduceValues(flags) ?? ({} as FlagsContextModel), [flags])

  return <FlagsContext.Provider value={value}>{children}</FlagsContext.Provider>
}

export const useFlags = () => useContext(FlagsContext)

const reduceValues = (flags: FlagsQueryModel): FlagsContextModel =>
  flags?.reduce<FlagsContextModel>((acc, item) => {
    acc[item.nome] = item.valor || false
    return acc
  }, {} as FlagsContextModel)
